import React from 'react'

export default function POItemFooterStyle() {
  return (
    <React.Fragment>
      <style jsx="true">
      {`
        #po-item-footer-container {
          display: flex;
          padding: 3px;
        }
        .translist-button-container {
          flex: 1;
          display: flex;
          justify-content: flex-end;
        }
        .notification {
          font-size: 1rem;
          color: blue'
          padding: 0 7px;
          padding-bottom: 5px;
          margin: auto 0;
        }
      `}
      </style>
    </React.Fragment>
  )
}
